import Icon from '../../components/Icon.vue'

Icon.register({"brands/buromobelexperte":{"width":448,"height":512,"paths":[{"d":"M0 32V160H128V32H0zM120 152H8V40H120V152zM160 32V160H288V32H160zM280 152H168V40H280V152zM320 32V160H448V32H320zM440 152H328V40H440V152zM0 192V320H128V192H0zM120 312H8V200H120V312zM160 192V320H288V192H160zM280 312H168V200H280V312zM320 192V320H448V192H320zM440 312H328V200H440V312zM0 352V480H128V352H0zM120 472H8V360H120V472zM160 352V480H288V352H160zM280 472H168V360H280V472zM320 352V480H448V352H320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/buromobelexperte.js
// module id = +VQf
// module chunks = 0